export const COMMON_SETTING_MAP = {
  industry: "Industry",
  corpOccupation: "CorpOccupation",
  corpCompanyUse: "CorpCompanyUse",
  corpMemberType: "CorpMemberType",
  corpPointUserImpossible: "CorpPointUserImpossible"
};

export const COMMON_LABEL_MAP = {
  industry: '業種',
  corpOccupation: '職種',
  corpCompanyUse: '企業利用登録フラグ',
  corpMemberType: '代表フラグ',
  corpPointUserImpossible: 'ポイント/ユーザ管理許可設定'
};

export const COMMON_ITEM_LOADING_MAP = {
  industry: { dataKey: "businessType", method: "loadSelectData" },
  corpOccupation: { dataKey: "occupation", method: "loadSelectData" },
  corpCompanyUse: { dataKey: "companyUse", method: "loadRadioData" },
  corpMemberType: { dataKey: "memberType", method: "loadRadioData" },
  corpPointUserImpossible: { dataKey: "pointUserImpossible", method: "loadRadioData" },
};

export const UPLOAD_FILE_SIZE_LIMIT = 7340032; // 7MB
export const UPLOAD_FILE_SIZE_LIMIT_TEXT = '7MB';
